import { Brand } from '../../constants/common.constants';

export type WelcomeModalConfig = {
  productName: string;
  termsUrl: string;
  privacyUrl: string;
  version: number;
}

const ELSEVIER_TERMS_URL = 'https://www.elsevier.com/legal/elsevier-website-terms-and-conditions';
const ELSEVIER_PRIVACY_URL = 'https://www.elsevier.com/legal/privacy-policy';

export const WelcomeDisclaimerConfigMap: Record<Brand, WelcomeModalConfig> = {
  [Brand.SHERPATH_AI]: {
    productName: 'Sherpath AI',
    termsUrl: ELSEVIER_TERMS_URL,
    privacyUrl: ELSEVIER_PRIVACY_URL,
    version: 1,
  },
  [Brand.NORA]: {
    productName: 'Nora',
    termsUrl: ELSEVIER_TERMS_URL,
    privacyUrl: ELSEVIER_PRIVACY_URL,
    version: 1,
  },
  [Brand.OSMOSIS_AI]: {
    productName: 'Osmosis AI',
    termsUrl: ELSEVIER_TERMS_URL,
    privacyUrl: ELSEVIER_PRIVACY_URL,
    version: 1,
  },
  [Brand.AI_COACH]: {
    productName: 'AI Coach',
    termsUrl: ELSEVIER_TERMS_URL,
    privacyUrl: ELSEVIER_PRIVACY_URL,
    version: 1,
  },
};
